import { computed } from 'vue';
import { useStore } from 'vuex';
import { getInitials } from '@/features/Settings/utils';

export const useUserProfile = () => {
  const store = useStore();
  const userProfile = computed(() => store.state.userProfile);
  const organizationNames = computed(() =>
    store.state.organizations?.map((o) => o?.name).filter(Boolean)
  );
  const initials = computed(() => {
    return getInitials(userProfile.value);
  });
  const email = computed(() => store.state.userProfile?.email);
  const userId = computed(() => store.state.userProfile?.id);
  return { userProfile, initials, organizationNames, email, userId };
};
